import { React, useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useParams } from 'react-router-dom';
import { Card, Typography } from 'antd';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';
import { CheckIcon } from '@chakra-ui/icons';
import { CornerDownLeft } from 'lucide-react';
import TaskmodalActivity from './TaskmodalActivity';
import dayjs from 'dayjs';
import SkeletonWithLoaders from 'components/common/Spinner';
import { useNavigate } from 'react-router-dom';
import SubtaskObject from '@atlaskit/object/subtask';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import LogWork from './LogWork';
import LinkWorkItemInput from './LinkWorkItemInput';
import ListLinkedWorkItems from './ListLinkedWorkItems';

import { ThunderboltOutlined } from '@ant-design/icons';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  HStack,
  Input,
  Avatar,
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Select,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react';
import { FaLock, FaEye, FaShareAlt, FaEdit } from 'react-icons/fa';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { MdOutlinePerson } from 'react-icons/md';
import CreatableSelect from 'react-select/creatable';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import { Tooltip } from '@chakra-ui/react';
import UserAvatar from '../../../../components/userAvatar/index';
import { setassigneelist } from 'store/actions';
import { useDispatch } from 'react-redux';
import { setTaskstatuslist } from 'store/actions';
import WebLink from './WebLink';
import WebLinkList from './ListWebLinks';

import { AddIcon, ChevronDownIcon, CloseIcon } from '@chakra-ui/icons';

import SubTaskModal from './SubTaskModal';

import Cookies from 'js-cookie';

const NewTabtaskdetails = ({
  isOpen,
  onClose,
  taskDetails,
  // assigneeList,
  // statusList,
  getTaskBoardDetails,
  openInNewTab = false,
  //   projectId
}) => {
  const { Title } = Typography;
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [description, setDescription] = useState('');
  const [editedTitle, setEditedTitle] = useState('');
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [reloadSubtasks, setReloadSubtasks] = useState(0);
  const [assigneeList, setassigneeList] = useState([]);
  const [statusList, setstatusList] = useState([]);
  const [epicList, setEpicList] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const quillRef = useRef(null);

  const [selectedLabel, setSelectedLabel] = useState([]);
  const [labellist, setLabelList] = useState([]);
  const [taskdata, setTaskData] = useState({});
  const [sprintlist, setSprintlist] = useState({});
  const [selectedSprint, setSelectedSprint] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentInput, setCommentInput] = useState('');
  const [replyInput, setReplyInput] = useState({});
  const [activeReply, setActiveReply] = useState(null);
  const [mentionQuery, setMentionQuery] = useState('');
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [mentionPosition, setMentionPosition] = useState({ top: 0, left: 0 });
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [newstatus, setnewstatus] = useState('');
  const [showChildInput, setShowChildInput] = useState(false);
  const [childTaskTitle, setChildTaskTitle] = useState('');
  const [childTasks, setChildTasks] = useState([]);
  const [loadingSubtasks, setLoadingSubtasks] = useState(false);
  const [editableTasks, setEditableTasks] = useState({});
  const [subtaskmodal, setSubtaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [epicModalOpen, setEpicModalOpen] = useState(false);
  const [selectedEpic, setSelectedEpic] = useState('');
  const [loading, setLoading] = useState(true);
  const [visibleReplies, setVisibleReplies] = useState({});
  const [selectedparent, setSelectedParent] = useState(null);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [isEditingComment, setIsEditingComment] = useState(false);
  const [activeReplyEditor, setActiveReplyEditor] = useState(null);
  const [openLinkWorkItem, setOpenLinkWorkItem] = useState(false);
  const [refreshLinkedItems, setRefreshLinkedItems] = useState(false);
  const [localIssueType, setLocalIssueType] = useState(
      taskdata?.issue_type_id
    );
  
    const [issuePopoverOpen, setIssuePopoverOpen] = useState(false);
 
  const [showWebLink, setShowWebLink] = useState(false);
  const [refreshLinks, setRefreshLinks] = useState(false);
  const { projectId, issuetypeId, taskId } = useParams();
  const issueId = taskId;

  const [panelOpen, setPanelOpen] = useState(isOpen);
  const [panelWidth, setPanelWidth] = useState(400);
  const [refreshKey, setRefreshKey] = useState(0);
  const isResizingRef = useRef(false);
  const innerResizingRef = useRef(false);
  const startInnerXRef = useRef(0);
  const MIN_WIDTH = 250;
  const getMaxWidth = () =>
    Math.min(window.innerWidth * 0.5, window.innerWidth - 250);
  // 50% of screen or leave 250px for left panel

  const [rightWidth, setRightWidth] = useState(() =>
    Math.min(Math.max(window.innerWidth * 0.4, MIN_WIDTH), getMaxWidth()),
  );

  const resizingRef = useRef(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  const onMouseDown = (e) => {
    resizingRef.current = true;
    startXRef.current = e.clientX;
    startWidthRef.current = rightWidth;
    document.body.style.userSelect = 'none';

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (e) => {
    if (!resizingRef.current) return;
    const dx = e.clientX - startXRef.current;

    let newW = startWidthRef.current - dx; // drag right -> shrink
    const MAX_WIDTH = getMaxWidth();
    newW = Math.min(Math.max(newW, MIN_WIDTH), MAX_WIDTH);
    setRightWidth(newW);
  };

  const onMouseUp = () => {
    resizingRef.current = false;
    document.body.style.userSelect = '';
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  // Update rightWidth dynamically on window resize
  useEffect(() => {
    const handleResize = () => {
      setRightWidth((prev) => Math.min(prev, window.innerWidth * 0.5));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //   const innerResizingRef = useRef(false);
  //   const startInnerXRef = useRef(0);
  const startRightWidthRef = useRef(0);

  const onMouseDownInner = (e) => {
    innerResizingRef.current = true;
    startInnerXRef.current = e.clientX;
    startRightWidthRef.current = rightWidth;
    document.addEventListener('mousemove', onMouseMoveInner);
    document.addEventListener('mouseup', onMouseUpInner);
  };

  const onMouseMoveInner = (e) => {
    if (!innerResizingRef.current) return;
    const dx = e.clientX - startInnerXRef.current;

    // ✅ Flip direction: drag right → shrink right box
    const newWidth = Math.min(
      Math.max(startRightWidthRef.current - dx, 250),
      700,
    );
    setRightWidth(newWidth);
  };

  const onMouseUpInner = () => {
    innerResizingRef.current = false;
    document.removeEventListener('mousemove', onMouseMoveInner);
    document.removeEventListener('mouseup', onMouseUpInner);
  };

  const handleLogSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  // keep panelOpen synced with isOpen prop
  useEffect(() => {
    setPanelOpen(isOpen);
  }, [isOpen]);

  // optional threshold to stack panes vertically when panel is narrow
  const columnThreshold = 520;
  const PANEL_MIN_WIDTH = 320; // never go smaller than this
  const PANEL_MAX_WIDTH = 800; // never go wider than this

  // mouse handlers for horizontal resize
  const onMouseDownResizer = (e) => {
    isResizingRef.current = true;
    startXRef.current = e.clientX;
    startWidthRef.current = panelWidth;
    document.addEventListener('mousemove', onMouseMoveResizer);
    document.addEventListener('mouseup', onMouseUpResizer);
    e.preventDefault();
  };

  const onTouchStartResizer = (e) => {
    isResizingRef.current = true;
    startXRef.current = e.touches[0].clientX;
    startWidthRef.current = panelWidth;
    document.addEventListener('touchmove', onTouchMoveResizer, {
      passive: false,
    });
    document.addEventListener('touchend', onTouchEndResizer);
  };

  const IssueIcon = ({ type }) => {
    const style = { flexShrink: 0 };

    switch (type) {
      case 'TASK':
        return <TaskObject size="medium" style={style} />;

      case 'STORY':
        return <StoryObject size="medium" style={style} />;

      case 'BUG':
        return <BugObject size="medium" style={style} />;

      default:
        return <TaskObject size="medium" style={style} />;
    }
  };

  const ISSUE_TYPES = [
      {
        id: 1,
        label: 'TASK',
        icon: <TaskObject size="small" />,
      },
      {
        id: 2,
        label: 'STORY',
        icon: <StoryObject size="small" />,
      },
      {
        id: 3,
        label: 'BUG',
        icon: <BugObject size="small" />,
      },
    ];
  
    const selectedIssue =
      ISSUE_TYPES.find((i) => i.id === localIssueType) ||
      ISSUE_TYPES[0];

  const onMouseMoveResizer = (e) => {
    if (!isResizingRef.current) return;
    const dx = startXRef.current - e.clientX; // panel anchored right -> moving left increases width
    const newWidth = Math.min(
      Math.max(startWidthRef.current + dx, 320),
      window.innerWidth - 120,
    );
    setPanelWidth(newWidth);
  };

  const onTouchMoveResizer = (e) => {
    if (!isResizingRef.current) return;
    e.preventDefault();
    const touchX = e.touches[0].clientX;
    const dx = startXRef.current - touchX;
    const newWidth = Math.min(
      Math.max(startWidthRef.current + dx, 320),
      window.innerWidth - 120,
    );
    setPanelWidth(newWidth);
  };

  const onMouseUpResizer = () => {
    isResizingRef.current = false;
    document.removeEventListener('mousemove', onMouseMoveResizer);
    document.removeEventListener('mouseup', onMouseUpResizer);
  };

  const onTouchEndResizer = () => {
    isResizingRef.current = false;
    document.removeEventListener('touchmove', onTouchMoveResizer);
    document.removeEventListener('touchend', onTouchEndResizer);
  };

  const handleOpenLinkWorkItem = () => {
    setOpenLinkWorkItem(true);
  };

  //     const onMouseDownInner = (e) => {
  //     innerResizingRef.current = true;
  //     startInnerXRef.current = e.clientX;
  //     startInnerWidthRef.current = innerBoxWidth;
  //     document.addEventListener('mousemove', onMouseMoveInner);
  //     document.addEventListener('mouseup', onMouseUpInner);
  //     e.preventDefault();
  //   };

  //   const onMouseMoveInner = (e) => {
  //     if (!innerResizingRef.current) return;
  //     const dx = e.clientX - startInnerXRef.current;
  //     const newWidth = Math.min(Math.max(startInnerWidthRef.current - dx, 250), 700);
  //     setInnerBoxWidth(newWidth);
  //   };

  //   const onMouseUpInner = () => {
  //     innerResizingRef.current = false;
  //     document.removeEventListener('mousemove', onMouseMoveInner);
  //     document.removeEventListener('mouseup', onMouseUpInner);
  //   };

  // close handler
  const handleClosePanel = () => {
    // call your save + refresh like before
    handleCloseWithSave(); // this already calls handleTaskUpdate, handleAddLabel, getTaskBoardDetails, onClose()
    setPanelOpen(false);
  };
  // const [activeReply, setActiveReply] = useState(null);
  const [storyPoints, setStoryPoints] = useState('');

  const roleId = Number(Cookies.get('task-role-id'));

  // To store tagged usernames & ids

  const handleCloseWithSave = () => {
    handleTaskUpdate();

    getTaskBoardDetails();

    onClose();
  };

  const triggerRefresh = () => {
    setRefreshLinkedItems((prev) => !prev);
  };

  const formatDateInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Still YYYY-MM-DD, but local
  };

  const [dueDate, setDueDate] = useState(formatDateInput(taskdata.due_date));
  const [startDate, setStartDate] = useState(
    formatDateInput(taskdata.start_date),
  );

  const handleDeleteComment = async (commentId) => {
    try {
      const reqBody = {
        project_id: taskdata.project_id,
        comment_id: commentId,
      };

      const res = await httpInjectorService.deletetaskcomment(reqBody);
      if (res.status === 'success') {
        toast.success(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        gettaskcomments();
      } else {
        toast.error(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Something went wrong while deleting comment');
    }
  };
  const handleCancel = () => {
    // setEditedTitle(taskdata?.task_title || "");
    setIsEditingTitle(false);
  };

  const handleEditComment = async (commentId, updatedText) => {
    try {
      const reqBody = {
        project_id: projectId,
        comment_id: commentId,
        comment_text: updatedText,
      };

      const res = await httpInjectorService.edit_comment(reqBody);
      if (res.status === 'success') {
        toast.success(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        gettaskcomments();
      } else {
        toast.error(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Something went wrong while updating comment');
    }
  };

  const toggleReplies = (commentId, totalReplies) => {
    setVisibleReplies((prev) => ({
      ...prev,
      [commentId]:
        prev[commentId] && prev[commentId] < totalReplies
          ? totalReplies // show all
          : 2, // collapse back to 2
    }));
  };

  const getprojectAssignedEmployee = async () => {
    try {
      let response = await httpInjectorService.getProjectAssignedEmployeelist(
        taskDetails?.project_id ? taskDetails.project_id : projectId,
      );
      if (response.status === 'success') {
        setassigneeList(response.data);

        dispatch(setassigneelist(response.data));
      } else {
        dispatch(setassigneelist([]));
        setassigneeList([]);
      }
    } catch (error) {}
  };

  const listBoardStatus = async () => {
    let project_id = taskDetails?.project_id
      ? taskDetails.project_id
      : projectId;
    try {
      const response = await httpInjectorService.ListBoardStatus(project_id);
      if (response.status === 'success' && Array.isArray(response.data)) {
        const statusList = response?.data;
        setstatusList(statusList);
        dispatch(setTaskstatuslist(statusList));
      } else {
        // setStatus([]);
        dispatch(setTaskstatuslist([]));
        setstatusList(statusList);

        // set({});
      }
    } catch (error) {
      throw error;
    }
  };

  // const handleAddLabel = async () => {
  //   try {
  //     if (!selectedLabel || selectedLabel?.length === 0) return;

  //     const newLabels = selectedLabel.filter((label) => label.__isNew__);
  //     const existingLabels = selectedLabel.filter((label) => !label.__isNew__);

  //     const newLabelNames = newLabels?.map((label) => label.label);
  //     const existingLabelIds = existingLabels?.map((label) => label.value);

  //     const requestBody = {
  //       project_id: projectId,
  //       task_id: taskId,
  //       sprint_id: taskDetails.task.sprint_id,
  //     };

  //     if (newLabelNames?.length > 0) {
  //       requestBody.new_label_name = newLabelNames;
  //     }

  //     if (existingLabelIds?.length > 0) {
  //       requestBody.labels_id = existingLabelIds;
  //     }

  //     const response = await httpInjectorService.createLabel(requestBody);

  //     if (response.status === 'success') {
  //       // toast.success(response.message || 'Labels added to task successfully', {
  //       //   position: 'top-right',
  //       //   autoClose: 3000,
  //       // });
  //       getTaskBoardDetails();
  //     } else {
  //       // toast.error(response.message || 'Failed to add labels', {
  //       //   position: 'top-right',
  //       //   autoClose: 3000,
  //       // });
  //     }

  //     setSelectedLabel([]);
  //   } catch (error) {
  //     console.error(error);
  //     toast.error('Something went wrong while adding labels', {
  //       position: 'top-right',
  //       autoClose: 3000,
  //     });
  //   }
  // };

  const handleAddLabel = async (updatedLabels = selectedLabel) => {
    try {
      // Always use the latest labels passed from onChange
      if (!updatedLabels || updatedLabels.length === 0) {
      }

      const newLabels = updatedLabels.filter((label) => label.__isNew__);
      const existingLabels = updatedLabels.filter((label) => !label.__isNew__);

      const newLabelNames = newLabels.map((label) => label.label);
      const existingLabelIds = existingLabels.map((label) => label.value);

      const requestBody = {
        project_id: projectId,
        issue_id: issueId,
      };

      // Attach ONLY if present
      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }
      requestBody.labels_id = existingLabelIds; // even if empty

      const response = await httpInjectorService.createLabel(requestBody);

      if (response.status !== 'success') {
        // error toast if needed
      }
    } catch (error) {
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const getLabelList = async () => {
    try {
      const response = await httpInjectorService.getlabelList(projectId);
      if (response.status === 'success') {
        setLabelList(response.data);
      } else {
        setLabelList([]);
      }
    } catch (error) {
      throw error;
    }
  };

  const gettaskdata = async () => {
    let reqbody = {
      project_id: projectId,
      issue_id: issueId,
      issue_type_id: issuetypeId,
    };
    try {
      const response = await httpInjectorService.gettaskdata(reqbody);

      if (response.status === 'success') {
        setTaskData(response.data);
      } else {
        setTaskData({});
      }
    } catch (error) {
      throw error;
    }
  };

  const handleEditChange = (subtaskId, field, value) => {
    setEditableTasks((prev) => ({
      ...prev,
      [subtaskId]: {
        ...prev[subtaskId],
        [field]: value,
      },
    }));
  };

  const handleopensubtaskmodal = (task) => {
    setSelectedSubtask(task);
    setSubtaskModal(true);
  };

  const saveSubtask = async (subtaskId, updatedFields = {}) => {
    const edited = editableTasks[subtaskId] || {};
    const original = childTasks?.find((t) => t.subtask_id === subtaskId);

    if (!original) {
      return;
    }

    const reqBody = {
      project_id: projectId, // or dynamic
      subtask_id: subtaskId,
      title: edited.title !== undefined ? edited.title : original.subtask_title,
      subtask_status: updatedFields.status
        ? updatedFields.status
        : original.status,
      subtask_priority: updatedFields.priority
        ? updatedFields.priority
        : original.priority,
      subtask_assignee_id: updatedFields.assignee_id
        ? updatedFields.assignee_id
        : original.assignee_id,
    };

    try {
      const response = await httpInjectorService.updateSubtask(reqBody);
      if (response.status === 'success') {
        // Optionally refresh or give feedback
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    gettaskcomments();
    getprojectAssignedEmployee();
    listBoardStatus();
  }, []);

  const deleteChildTask = async (subtaskId) => {
    try {
      let reqbody = {
        project_id: projectId,
        subtask_ids: [subtaskId],
      };
      let response = await httpInjectorService.delete_subtask(reqbody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setChildTasks((prev) =>
          prev.filter((task) => task.subtask_id !== subtaskId),
        );
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      throw error;
    }
  };

  const gettaskcomments = async () => {
    let reqbody = {
      project_id: projectId,
      issue_id: taskId,
    };
    try {
      const res = await httpInjectorService.gettaskcomments(reqbody);
      if (res.status === 'success') {
        setComments(res.data);
      } else {
        console.error('Failed to fetch comments:', res.message);
      }
    } catch (err) {
      throw err;
    }
  };

  const getsprintlist = async () => {
    try {
      let response = await httpInjectorService.getsprintList(projectId);

      if (response.status === 'success') {
        const activeSprints = response.data?.active_sprints || [];

        // Convert to options format for CreatableSelect
        const options = activeSprints?.map((sprint) => ({
          label: sprint.sprint_name,
          value: sprint.sprint_id,
        }));

        setSprintlist(options);

        // Preselect based on taskDetails
        const currentSprintName = taskdata?.sprint_name || ' ';
        const matchedSprint = options?.find(
          (opt) => opt.label === currentSprintName,
        );

        if (matchedSprint) {
          setSelectedSprint(matchedSprint);
        }
      } else {
        setSprintlist([]);
      }
    } catch (error) {
      setSprintlist([]);
    }
  };

  useEffect(() => {
    if (taskId) {
      gettaskdata(taskId);

      getsprintlist();
      getLabelList();
      getEpiclist();
    }
  }, []);

  useEffect(() => {
    if (taskdata) {
      setDescription(taskdata?.description);
      setDueDate(formatDateInput(taskdata?.due_date) || '');
      setStartDate(formatDateInput(taskdata?.start_date) || '');
      setStoryPoints(taskdata?.story_points ?? '');
      if (taskdata?.epic_id && taskdata?.epic_name) {
        setSelectedParent({
          value: taskdata.epic_id,
          label: taskdata.epic_name,
        });
      } else {
        setSelectedParent(null);
      }
    }
  }, [isOpen, taskdata]);

  const sprintOptions = Array.isArray(sprintlist)
    ? sprintlist
    : sprintlist?.data || [];

  const handleTaskUpdate = async (emp = {}) => {
    const finalBody = {
      issue_id: taskdata.task?.issue_id || taskdata.issue_id,
      project_id: taskdata.project_id,
      issue_type_id:emp?.issue_type_id || taskdata.task?.issue_type_id || taskdata.issue_type_id,
      epic_id: emp?.value || taskdata.epic_id || null,
      sprint_id: selectedSprint?.value || taskdata.sprint_id || null,
      story_points: storyPoints || taskdata.story_points || null,
      assignee_id: emp?.user_id || taskdata.assignee_id || null,
      issue_title: editedTitle || taskdata?.issue_title,
      description: description?.trim() || taskdata.description || '',
      issue_status: emp.status_name || taskdata.issue_status,
      task_priority: taskdata.task_priority,
      start_date: startDate || taskdata.start_date,
      due_date: dueDate || taskdata.due_date,
    };
    try {
      const response = await httpInjectorService.Taskedit(finalBody);
      if (response?.status === 'success') {
        gettaskdata();
       
      }
    } catch (error) {
      throw error;
    }
  };
  const debouncedUpdate = useCallback(
    debounce(() => handleTaskUpdate(), 300),
    [handleTaskUpdate],
  );

  const handleCommentChange = (value, delta, source, editor) => {
    setCommentInput(value);
    // plain text from quill (always ends with \n)
    const plain = editor.getText();
    const cleaned = plain.replace(/\n$/, '');

    // match @query at end
    const match = cleaned.match(/@(\w*)$/);

    if (match) {
      const query = match[1].toLowerCase();
      setMentionQuery(query);

      const suggestions = assigneeList.filter((user) =>
        user.username.toLowerCase().includes(query),
      );

      setMentionSuggestions(suggestions);

      // ✅ Get caret position to position popover
      const quill = quillRef.current.getEditor();
      const range = quill.getSelection();

      if (range) {
        const bounds = quill.getBounds(range.index);
        setMentionPosition({
          top: bounds.bottom,
          left: bounds.left,
        });
      }
    } else {
      setMentionQuery('');
      setMentionSuggestions([]);
    }
  };

  const justOpenedRef = useRef(true);

  const getEpiclist = async () => {
    const queryParams = `?project_id=${projectId}`;
    try {
      const response = await httpInjectorService.get_epic(queryParams);
      setEpicList(response.data);
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (epicModalOpen) {
      getEpiclist(); // fetch only when modal is opened
    }
  }, [epicModalOpen]);

  const getsubtaskList = async () => {
    setLoadingSubtasks(true);
    let reqbody = {
      project_id: projectId,
      issue_id: taskId,
    };
    try {
      const response = await httpInjectorService.getsubtaskList(reqbody);
      setChildTasks(response?.data);
      // assuming array of { id, title }
    } catch (error) {
      throw error;
    } finally {
      setLoadingSubtasks(false);
    }
  };

  const isEditable = [1, 2, 3].includes(roleId);

  useEffect(() => {
    getsubtaskList();
  }, [taskId]);

  const handleAddSubtask = async () => {
    let reqbody = {
      project_id: projectId,
      issue_id: taskdata.issue_id,
      issue_type_id: taskdata.issue_type_id,
      issue_type: taskdata.issue_name,
      title: childTaskTitle || '',
      description: null,
      subtask_status: 'TO DO',
      subtask_priority: 'Medium',
      start_date: null,
      due_date: null,
      labels_id: null,
      subtask_assignee_id: null,
    };

    try {
      const response = await httpInjectorService.addSubtask(reqbody);
      if (response.status === 'success') {
        setChildTaskTitle('');
        setShowChildInput(false);
        setReloadSubtasks((prev) => prev + 1);
        getsubtaskList(); // Refresh list
      } else {
        console.error('Failed to add subtask');
      }
    } catch (error) {
      throw error;
    }
  };

  const handlesubtaskmodal = () => {
    setSubtaskModal(false);
  };

  useEffect(() => {
    if (taskdata?.labels) {
      const formatted = taskdata.labels.map((label) => ({
        label: label.label_name,
        value: label.label_id,
        __isNew__: false,
      }));
      setSelectedLabel(formatted);
    }
  }, [taskdata]);

  // const updatesubtask=async()=>{

  //   let reqbody={
  //     project_id:5,
  // subtask_id: 11,
  // title: "subtask edit test_12",
  // subtask_status: "Blocked",
  // subtask_priority: "Medium",
  // subtask_assignee_id: 157
  //   }
  //   try{
  //     let response=await httpInjectorService.updateSubtask(reqbody)
  //     if(response.status==="success"){

  //     }
  //   }catch(error){

  //   }
  // }

  useEffect(() => {
    if (isOpen) {
      justOpenedRef.current = true;
    }
  }, [isOpen]);

  const handleStatusChange = (status) => {
    setnewstatus(status);
  };

  const formatAssigneeLabel = (username) => {
    if (!username) return 'Unassigned';

    const nameParts = username.trim().split(' ');
    const initials = nameParts
      .map((n) => n[0])
      .join('')
      .toUpperCase();

    return `${initials} - ${username}`;
  };

  const handleSaveLink = (data) => {
   
    setRefreshLinks((prev) => !prev);
    // you can store it, send API, etc
    setShowWebLink(false);
  };

  useEffect(() => {
    if (taskId) {
      setLoading(true);

      const fetchAllData = async () => {
        try {
          await Promise.all([
            gettaskdata(),
            getsprintlist(),
            getLabelList(),
            gettaskcomments(),
            getsubtaskList(),
          ]);
        } catch (error) {
          throw error;
        } finally {
          setLoading(false); // ✅ hide spinner after all API calls finish
        }
      };

      fetchAllData();
    }
  }, [isOpen, taskDetails]);

  //   const isStacked = panelWidth < columnThreshold;
  const totalWidth = 1550;
  const getStatusColors = (status = '') => {
    const s = status.toUpperCase(); // normalize

    switch (s) {
      case 'DONE':
        return { bg: 'green.300', color: 'black' };

      case 'TO DO':
        return { bg: 'gray.300', color: 'black' };

      default:
        return { bg: 'blue.300', color: 'black' };
    }
  };

  const currentStatus = newstatus || taskdata?.issue_status;
  const { bg, color } = getStatusColors(currentStatus);

  const status = taskdata?.subtask_status_count || {};
 

  const toDo = parseInt(status['TO DO'] || 0, 10);
  const review = parseInt(status['REVIEW'] || 0, 10);
  const inProgress = parseInt(status['IN PROGRESS'] || 0, 10);
  const done = parseInt(status?.DONE || 0, 10);
 

  const total = parseInt(status?.task_count || 0, 10);
  

  // Calculate % safely
  const donePercent = total > 0 ? (done / total) * 100 : 0;

  return (
    <Card
      style={{
        position: 'fixed',
        top: '60px',
        left: '80px',
        right: '10px',
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <div>
        <Flex
          align="center"
          justify="space-between"
          px={6}
          py={3}
          borderBottom="1px solid #e2e8f0"
          flex="0 0 64px" // fixed header height
          minHeight="64px"
          zIndex="4"
          bg="white"
        >
         <HStack spacing={1} align="center">
                        {/* Epic */}
                        <HStack spacing={1} align="center">
                          <ThunderboltOutlined
                            style={{
                              color: '#884B9E',
                              fontSize: '18px',
                            }}
                          />
        
                          <Text fontSize="md" color="gray.600" mt="12px">
                            {selectedEpic || taskdata?.epic_key
                              ? epicList?.find(
                                (epic) =>
                                  epic.epic_id ===
                                  (selectedEpic || taskdata?.epic_key),
                              )?.epic_key || taskdata?.epic_key
                              : [1, 2, 3].includes(roleId) && (
                                <Button
                                  onClick={() => setEpicModalOpen(true)}
                                  variant="ghost"
                                  size="md"
                                  p={0}
                                  fontSize="18px"
                                  minW="auto"
                                  height="auto"
                                  color="gray.500"
                                  _hover={{ bg: 'transparent', color: 'gray.600' }}
                                  leftIcon={<FaEdit size="14px" />}
                                >
                                  Add epic
                                </Button>
                              )}
                          </Text>
        
                          <Text fontSize="md" color="gray.600" mt="12px">
                            /
                          </Text>
                        </HStack>
        
                        {/* Issue Type */}
                        <Popover
                          isOpen={issuePopoverOpen}
                          onClose={() => setIssuePopoverOpen(false)}
                          placement="bottom-start"
                        >
                          <PopoverTrigger>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                setIssuePopoverOpen(!issuePopoverOpen);
                              }}
                              style={{
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 6,
                              }}
                            >
                              {selectedIssue.icon}
        
                              <Text fontSize="md" color="gray.600" m={0}>
                                {taskdata?.issue_key || taskDetails?.task?.issue_key}
                              </Text>
                            </div>
                          </PopoverTrigger>
        
                          <PopoverContent width="140px">
                            <PopoverBody p={1}>
                              {ISSUE_TYPES.map((item) => (
                                <div
                                  key={item.id}
                                  onClick={() => {
                                    setLocalIssueType(item.id);
        
                                    handleTaskUpdate({
                                      issue_type_id: item.id,
                                    });
        
                                    setIssuePopoverOpen(false);
                                  }}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '6px 8px',
                                    borderRadius: 6,
                                    cursor: 'pointer',
                                    fontSize: '13px', // <- add this
                                  }}
                                >
                                  {item.icon}
        
                                  <span style={{ fontSize: '13px' }}>
                                    {item.label}
                                  </span>
                                </div>
                              ))}
                            </PopoverBody>
                          </PopoverContent>
                        </Popover>
                      </HStack>

          <HStack spacing={2}>
            <IconButton
              icon={<FaLock />}
              size="lg"
              variant="ghost"
              aria-label="lock"
            />
            <LogWork
              work_Id={taskdata?.issue_id}
              work_Type="ISSUE"
              taskDetails={taskdata}
              onSaved={handleLogSaved}
            />
            <IconButton
              icon={<FaEye />}
              size="lg"
              variant="ghost"
              aria-label="view"
            />
            <IconButton
              icon={<FaShareAlt />}
              size="lg"
              variant="ghost"
              aria-label="share"
            />
            <IconButton
              icon={<AiOutlineThunderbolt />}
              size="lg"
              variant="ghost"
              aria-label="action"
            />

            {/* <ModalCloseButton position="static" /> */}
          </HStack>
        </Flex>

        <Box
          width="100%"
          height="100%"
          display="flex"
          flexDirection="row"
          bg="white"
          overflowY="auto"
        >
          {/* Inner scrollable wrapper */}

          {loading ? (
            <Flex justify="center" align="center" w="100%" h="300px">
              <SkeletonWithLoaders />
            </Flex>
          ) : (
            <Flex width="100%">
              <Box
                flex="1"
                p={6}
                overflowY="auto"
                bg="white"
                style={{
                  height: 'calc(100vh - 180px)', // adjust top/bottom offset as needed
                  display: 'flex',
                  flexDirection: 'column',
                  overflowY: 'auto', // vertical scrolling
                  // prevent horizontal scroll
                  transition: 'height 0.2s ease', // smooth height change
                }}
              >
                <Box mb={4}>
                  {!isEditingTitle ? (
                    // --- Normal Text ---
                    <Text
                      fontSize="2xl"
                      fontWeight="bold"
                      cursor="pointer"
                      onClick={() => {
                        if ([1, 2, 3].includes(roleId)) {
                          setEditedTitle(taskdata?.issue_title);
                          setIsEditingTitle(true);
                        }
                      }}
                    >
                      {editedTitle || taskdata?.issue_title || 'Task Title'}
                    </Text>
                  ) : (
                    // --- Editing Mode ---
                    <Box position="relative" width="100%">
                      <Input
                        value={editedTitle}
                        onChange={(e) => setEditedTitle(e.target.value)}
                        size="lg"
                        fontSize="2xl"
                        fontWeight="bold"
                        autoFocus
                        height="40px"
                        focusBorderColor="gray.300"
                        borderRadius="md"
                      />

                      {/* Wrapper ABSOLUTE but not blocking input */}
                      <HStack
                        spacing={2}
                        position="absolute"
                        right="0"
                        top="100%"
                        mt={1}
                        pointerEvents="none"
                      >
                        <Box
                          p={1}
                          border="1px solid #d1d5db"
                          borderRadius="sm"
                          cursor="pointer"
                          pointerEvents="auto"
                          onClick={() => {
                            handleTaskUpdate(); // call the update function
                            setIsEditingTitle(false); // exit edit mode
                          }}
                        >
                          <CheckIcon boxSize={4} color="grey" />
                        </Box>

                        <Box
                          p={1}
                          border="1px solid #d1d5db"
                          borderRadius="sm"
                          cursor="pointer"
                          pointerEvents="auto"
                          onClick={handleCancel}
                        >
                          <CloseIcon boxSize={4} color="grey" />
                        </Box>
                      </HStack>
                    </Box>
                  )}

                  {/* <Menu>
                         <MenuButton
                           as={IconButton}
                           icon={<AddIcon />}
                           size="sm"
                           colorScheme="gray"
                           variant="ghost"
                           mt={1}
                           aria-label="Add actions"
                         />
                         <MenuList>
                           <MenuItem onClick={() => setShowChildInput(true)}>
                             Create child work item
                           </MenuItem>
                           <MenuItem
                             onClick={() => console.log('Assign task clicked')}
                           >
                             Add connected work
                           </MenuItem>
                           <MenuItem
                             onClick={() => console.log('Add attachment clicked')}
                           >
                             Add Attachment
                           </MenuItem>
                           <MenuItem
                             onClick={() => console.log('Add comment clicked')}
                           >
                             Add web link
                           </MenuItem>
                           <MenuItem
                             onClick={() => console.log('Assign task clicked')}
                           >
                             Page
                           </MenuItem>
                           <MenuItem
                             onClick={() => console.log('Add attachment clicked')}
                           >
                             Whiteboard
                           </MenuItem>
                         </MenuList>
                       </Menu> */}
                  {[1, 2, 3].includes(roleId) && (
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<AddIcon />}
                        size="sm"
                        aria-label="Add actions"
                        bg="#f3f4f6"
                        border="1px solid #d1d5db"
                        borderRadius="md"
                        _hover={{ bg: '#e5e7eb' }}
                        _active={{ bg: '#e5e7eb' }}
                        color="gray.700"
                        mt={1}
                        mb={30}
                      />
                      <MenuList zIndex={2}>
                        <MenuItem onClick={() => setShowChildInput(true)}>
                          Create child work item
                        </MenuItem>
                        <MenuItem onClick={handleOpenLinkWorkItem}>
                          Link work Items
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Add attachment clicked')}
                        >
                          Add Attachment
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            console.log('clicked');
                            setShowWebLink(true);
                          }}
                        >
                          Add web link
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Assign task clicked')}
                        >
                          Page
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Add attachment clicked')}
                        >
                          Whiteboard
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  )}
                </Box>

                <Box mb={6}>
                  <Text fontWeight="bold" fontSize="md" mb={2}>
                    Description
                  </Text>

                  {!isEditingDescription ? (
                    <Box
                      p={3}
                      border="1px solid #e2e8f0"
                      //   borderRadius="8px"
                      minH="60px"
                      bg="white"
                      onClick={() =>
                        [1, 2, 3].includes(roleId) &&
                        setIsEditingDescription(true)
                      }
                      cursor={
                        ![1, 2, 3].includes(roleId) ? 'not-allowed' : 'text'
                      }
                      fontSize="lg"
                    >
                      {description ? (
                        <Box
                          dangerouslySetInnerHTML={{ __html: description }}
                          fontSize="md"
                        />
                      ) : (
                        <Text color="gray.400" fontSize="md">
                          Add a description...
                        </Text>
                      )}
                    </Box>
                  ) : (
                    <Box>
                      <ReactQuill
                        theme="snow"
                        value={description}
                        onChange={setDescription}
                        placeholder="Write a description..."
                        modules={{
                          toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ list: 'ordered' }, { list: 'bullet' }],
                            [{ color: [] }, { background: [] }],
                            ['link', 'image', 'code-block'],
                            ['clean'],
                          ],
                        }}
                        style={{
                          backgroundColor: 'white',
                          //   borderRadius: '8px',
                          minHeight: '140px',
                          //   minHeight: '120px',
                          fontSize: '16px',
                          lineHeight: '1.5',
                        }}
                      />
                      <Flex justify="flex-start" mt={1} gap={2}>
                        <Button
                          size="sm"
                          colorScheme="blue"
                          borderRadius="0px"
                          onClick={() => {
                            setIsEditingDescription(false);
                            handleTaskUpdate('description', description); // ✅ Save on Done click
                          }}
                        >
                          save
                        </Button>
                        <Button
                          size="sm"
                          variant="ghost"
                          borderRadius="0px"
                          onClick={() => setIsEditingDescription(false)}
                        >
                          cancel
                        </Button>
                      </Flex>
                    </Box>
                  )}
                </Box>

                {openLinkWorkItem && (
                  <div style={{ marginTop: '16px' }}>
                    <LinkWorkItemInput
                      onCancel={() => setOpenLinkWorkItem(false)}
                      current_item_type={'issue'}
                      current_item_id={taskdata.issue_id}
                      onSuccess={triggerRefresh}
                    />
                  </div>
                )}
                {showWebLink && (
                  <WebLink
                    onClose={() => setShowWebLink(false)}
                    onSave={handleSaveLink}
                    work_id={taskdata.issue_id}
                    work_type={'issue'}
                  />
                )}

              

                <Tabs variant="unstyled">
                  {/* Tabs */}
                  <TabList gap={2}>
                    <Tab
                      fontSize="12px"
                      px="8px"
                      py="3px"
                      _selected={{
                        border: '1px solid #3182CE',
                        color: '#3182CE',
                        bg: 'white',
                        borderRadius: '4px',
                      }}
                    >
                      Subtasks
                    </Tab>

                    <Tab
                      fontSize="12px"
                      px="8px"
                      py="3px"
                      _selected={{
                        border: '1px solid #3182CE',
                        color: '#3182CE',
                        bg: 'white',
                        borderRadius: '4px',
                      }}
                    >
                      Linked Items
                    </Tab>
                  </TabList>

                  {/* Tab Content */}
                  <TabPanels mt={4}>
                    {/* Subtasks */}
                    <TabPanel p={0}>
                      {childTasks?.length > 0 && [1, 2, 3].includes(roleId) && (
                        <Box mt={6}>
                          <Text fontWeight="semibold" mb={2}>
                            SubTasks
                          </Text>
                          {taskdata?.subtask_status_count && (
                            <Box mb={1}>
                              <Flex align="center" gap={4}>
                                {/* Progress Bar */}
                                <Flex
                                  w="100%"
                                  h="10px"
                                  borderRadius="8px"
                                  overflow="hidden"
                                  bg="#E2E8F0"
                                >
                                  {(() => {
                                    const counts =
                                      taskdata.subtask_status_count;
                                    const total =
                                      Number(
                                        taskdata?.subtask_status_count
                                          ?.subtask_count,
                                      ) || 1;

                                    // Fixed
                                    const todo = Number(counts['TO DO'] || 0);
                                    const done = Number(counts['DONE'] || 0);

                                    // Dynamic statuses (merged into BLUE)
                                    let blue = 0;
                                    let blueStatusText = [];

                                    Object.keys(counts).forEach((key) => {
                                      if (
                                        key !== 'TO DO' &&
                                        key !== 'DONE' &&
                                        key !== 'subtask_count'
                                      ) {
                                        const c = Number(counts[key] || 0);
                                        blue += c;
                                        blueStatusText.push(`${key}: ${c}`);
                                      }
                                    });

                                    const todoPercent = (todo / total) * 100;
                                    const bluePercent = (blue / total) * 100;
                                    const donePercent = (done / total) * 100;

                                    return (
                                      <>
                                        {/* DONE (green) */}
                                        <Tooltip
                                          label={`DONE: ${done} of ${total}`}
                                          hasArrow
                                          placement="top"
                                        >
                                          <Box
                                            w={`${donePercent}%`}
                                            bg="#38A169"
                                            mx="1px"
                                            borderRadius="4px"
                                          />
                                        </Tooltip>

                                        {/* BLUE (other statuses) */}
                                        <Tooltip
                                          label={`IN PROGRESS: ${blue} of ${total}`}
                                          hasArrow
                                          placement="top"
                                        >
                                          <Box
                                            w={`${bluePercent}%`}
                                            bg="#3182CE"
                                            mx="1px"
                                            borderRadius="4px"
                                          />
                                        </Tooltip>
                                        {/* TO DO (grey) */}
                                        <Tooltip
                                          label={`TO DO: ${todo} of ${total}`}
                                          hasArrow
                                          placement="top"
                                        >
                                          <Box
                                            w={`${todoPercent}%`}
                                            bg="#A0AEC0"
                                            mx="1px"
                                            borderRadius="4px"
                                          />
                                        </Tooltip>
                                      </>
                                    );
                                  })()}
                                </Flex>

                                {/* Work Done Percentage */}
                                <Text fontWeight="600" whiteSpace="nowrap">
                                  Done: {Math.round(donePercent)}%
                                </Text>
                              </Flex>
                            </Box>
                          )}

                          <Box
                            borderWidth="1px"
                            borderRadius="md"
                            overflow="hidden"
                            boxShadow="sm"
                          >
                            <Box maxH="300px" overflowY="auto">
                              <Table size="sm" border="1px solid #E2E8F0">
                                <Thead
                                  bg="gray.100"
                                  position="sticky"
                                  top={0}
                                  zIndex={0}
                                >
                                  <Tr>
                                    <Th borderRight="1px solid #E2E8F0"></Th>
                                    <Th
                                      borderRight="1px solid #E2E8F0"
                                      w="300px"
                                    >
                                      Work
                                    </Th>
                                    <Th borderRight="1px solid #E2E8F0">
                                      Priority
                                    </Th>
                                    <Th borderRight="1px solid #E2E8F0">
                                      Assignee
                                    </Th>
                                    <Th>Status</Th>
                                  </Tr>
                                </Thead>

                                <Tbody>
                                  {childTasks?.map((task) => {
                                    const edited =
                                      editableTasks[task.subtask_id] || {};

                                    const assigneeIdToUse =
                                      edited.assignee_id !== undefined
                                        ? edited.assignee_id
                                        : task.assignee_id;

                                    const assigneeObj = assigneeList?.find(
                                      (a) => a.user_id === assigneeIdToUse,
                                    );

                                    const subtaskTitle =
                                      edited.title !== undefined
                                        ? edited.title
                                        : task?.subtask_title;

                                    const selectedStatus =
                                      edited.status || task.status || 'TO DO';

                                    const handleSave = () =>
                                      saveSubtask(task.subtask_id);

                                    return (
                                      <Tr key={task.subtask_id}>
                                        <Td
                                          w="150px"
                                          borderRight="1px solid #E2E8F0"
                                        >
                                          <Box
                                            as="button"
                                            onClick={() => {
                                              navigate(
                                                `/admin/taskBoard/${projectId}/subtaskDetails/${task.subtask_id}`,
                                              );
                                            }}
                                            display="flex"
                                            alignItems="center"
                                            gap="0px"
                                            bg="transparent"
                                            border="none"
                                            cursor="pointer"
                                            color="#3182ce"
                                            fontWeight="500"
                                            padding={0}
                                            _hover={{
                                              textDecoration: 'underline',
                                              color: '#0056b3',
                                            }}
                                          >
                                            <SubtaskObject
                                              size={20}
                                              stroke="#0052CC"
                                              fill="white"
                                              strokeWidth={2}
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                lineHeight: 1,
                                              }}
                                            />
                                            {task.subtask_key}
                                          </Box>
                                        </Td>

                                        {/* Editable title */}
                                        <Td
                                          borderRight="1px solid #E2E8F0"
                                          w="300px"
                                        >
                                          <Tooltip
                                            label={subtaskTitle}
                                            hasArrow
                                            placement="top"
                                            openDelay={300}
                                          >
                                            <Input
                                              size="sm"
                                              value={subtaskTitle}
                                              onChange={(e) =>
                                                handleEditChange(
                                                  task.subtask_id,
                                                  'title',
                                                  e.target.value,
                                                )
                                              }
                                              onKeyDown={(e) =>
                                                e.key === 'Enter' &&
                                                handleSave()
                                              }
                                              onBlur={handleSave}
                                            />
                                          </Tooltip>
                                        </Td>

                                        {/* Priority */}
                                        <Td borderRight="1px solid #E2E8F0">
                                          <Menu>
                                            <MenuButton
                                              as={Button}
                                              size="xs"
                                              variant="outline"
                                              colorScheme="gray"
                                              rightIcon={<ChevronDownIcon />}
                                            >
                                              {edited.priority ||
                                                task.priority ||
                                                'Medium'}
                                            </MenuButton>
                                            <MenuList>
                                              {['Low', 'Medium', 'High'].map(
                                                (priority) => (
                                                  <MenuItem
                                                    key={priority}
                                                    onClick={() => {
                                                      handleEditChange(
                                                        task.subtask_id,
                                                        'priority',
                                                        priority,
                                                      );
                                                      saveSubtask(
                                                        task.subtask_id,
                                                        { priority },
                                                      );
                                                    }}
                                                  >
                                                    {priority}
                                                  </MenuItem>
                                                ),
                                              )}
                                            </MenuList>
                                          </Menu>
                                        </Td>

                                        {/* Assignee */}
                                        <Td borderRight="1px solid #E2E8F0">
                                          <Menu isLazy>
                                            <Tooltip
                                              label={
                                                assigneeObj
                                                  ? assigneeObj.username
                                                  : 'Unassigned'
                                              }
                                              hasArrow
                                              placement="top"
                                              openDelay={300}
                                            >
                                              <MenuButton
                                                as={Button}
                                                variant="ghost"
                                                size="sm"
                                                rightIcon={<ChevronDownIcon />}
                                              >
                                                <Box>
                                                  <UserAvatar
                                                    username={
                                                      assigneeObj
                                                        ? assigneeObj.username
                                                        : 'Unassigned'
                                                    }
                                                    size={24}
                                                  />
                                                </Box>
                                              </MenuButton>
                                            </Tooltip>

                                            <MenuList
                                              maxH="200px"
                                              overflowY="auto"
                                              zIndex={1500}
                                            >
                                              {assigneeList?.map((assignee) => (
                                                <MenuItem
                                                  key={assignee.user_id}
                                                  onClick={() => {
                                                    handleEditChange(
                                                      task.subtask_id,
                                                      'assignee_id',
                                                      assignee.user_id,
                                                    );
                                                    saveSubtask(
                                                      task.subtask_id,
                                                      {
                                                        assignee_id:
                                                          assignee.user_id,
                                                      },
                                                    );
                                                  }}
                                                >
                                                  <Tooltip
                                                    label={assignee.username}
                                                    hasArrow
                                                    placement="right"
                                                    openDelay={300}
                                                  >
                                                    <Flex
                                                      align="center"
                                                      gap="2"
                                                    >
                                                      <UserAvatar
                                                        username={
                                                          assignee.username
                                                        }
                                                        size={24}
                                                      />
                                                      <Text fontSize="sm">
                                                        {assignee.username}
                                                      </Text>
                                                    </Flex>
                                                  </Tooltip>
                                                </MenuItem>
                                              ))}
                                            </MenuList>
                                          </Menu>
                                        </Td>

                                        {/* Status */}
                                        <Td>
                                          <Menu>
                                            <MenuButton
                                              as={Button}
                                              size="xs"
                                              variant="outline"
                                              colorScheme="gray"
                                              rightIcon={<ChevronDownIcon />}
                                            >
                                              {selectedStatus}
                                            </MenuButton>
                                            <MenuList>
                                              {statusList?.map((status) => (
                                                <MenuItem
                                                  key={status.status_name}
                                                  onClick={() => {
                                                    handleEditChange(
                                                      task.subtask_id,
                                                      'status',
                                                      status.status_name,
                                                    );
                                                    saveSubtask(
                                                      task.subtask_id,
                                                      {
                                                        status:
                                                          status.status_name,
                                                      },
                                                    );
                                                  }}
                                                >
                                                  {status.status_name}
                                                </MenuItem>
                                              ))}
                                            </MenuList>
                                          </Menu>
                                        </Td>
                                      </Tr>
                                    );
                                  })}
                                </Tbody>
                              </Table>
                            </Box>
                          </Box>
                        </Box>
                      )}
                    </TabPanel>

                    {/* Linked Items */}
                    <TabPanel p={0}>
                      <ListLinkedWorkItems
                        item_id={taskdata.issue_id}
                        item_type={'issue'}
                        refreshFlag={refreshLinkedItems}
                      />
                    </TabPanel>
                  </TabPanels>
                </Tabs>



                {showChildInput && (
                  <HStack mb={4} mt={3}>
                    <Text fontWeight="semibold" mb={2}>
                      Subtasks
                    </Text>
                    <Input
                      placeholder="What needs to be done?"
                      size="sm"
                      value={childTaskTitle}
                      onChange={(e) => setChildTaskTitle(e.target.value)}
                      onKeyDown={(e) => e.key === 'Enter' && handleAddSubtask()}
                    />
                    <Button
                      size="sm"
                      colorScheme="blue"
                      borderRadius="0px"
                      onClick={handleAddSubtask}
                    >
                      <CornerDownLeft />
                    </Button>
                    <Button
                      size="sm"
                      borderRadius="0px"
                      onClick={() => setShowChildInput(false)}
                    >
                      Cancel
                    </Button>
                  </HStack>
                )}

                  <WebLinkList
                  work_id={taskdata.issue_id}
                  work_type={'issue'}
                  refreshFlag={refreshLinks}
                />

                {/* Comment Input */}

                <Box>
                  <TaskmodalActivity
                    taskDetails={taskDetails}
                    taskdata={taskdata}
                    taskID={taskdata.issue_id}
                    projectId={taskdata.project_id}
                  />
                </Box>
              </Box>
              <Box
                width="6px"
                cursor="ew-resize"
                bg="gray.200"
                _hover={{ bg: 'gray.400' }}
                onMouseDown={onMouseDown}
              />
              {/* right side panel */}
              <Box
                flex="none"
                width={`${rightWidth}px`}
                p={6}
                pr={0}
                right={0}
                borderLeft="1px solid #e2e8f0"
                // bg="gray.50"
                overflowY="auto"
                style={{
                  height: 'calc(100vh - 180px)', // adjust top/bottom offset as needed
                  // display: 'flex',
                  flexDirection: 'column',
                  overflowY: 'auto', // vertical scrolling
                  // prevent horizontal scroll
                  transition: 'height 0.2s ease', // smooth height change
                }}
              >
                <Tooltip
                  label={!isEditable ? 'You do not have permission' : ''}
                >
                  <Menu isDisabled={!isEditable}>
                    <MenuButton
                      as={Button}
                      rightIcon={<ChevronDownIcon />}
                      size="sm"
                      mb={4}
                      p={0}
                      px={0}
                      minW="fit-content"
                      width="fit-content"
                      height="auto"
                      borderRadius="md"
                      bg={bg} // status background
                      color={color} // text color
                      border="1px solid #ccc"
                      _hover={{ bg }}
                      _active={{ bg }}
                    >
                      <Badge
                        bg="transparent"
                        color={color}
                        fontSize="0.8em"
                        p={1}
                      >
                        {currentStatus}
                      </Badge>
                    </MenuButton>

                    {isEditable && (
                      <MenuList>
                        {statusList.map((status) => {
                          const { bg, color } = getStatusColors(
                            status.status_name,
                          );
                          return (
                            <MenuItem
                              key={status.id}
                              onClick={() => {
                                handleStatusChange(status.status_name);
                                handleTaskUpdate(status);
                              }}
                            >
                              <Badge
                                bg={bg}
                                color={color}
                                fontSize="0.75em"
                                p={1}
                                borderRadius="md"
                              >
                                {status.status_name}
                              </Badge>
                            </MenuItem>
                          );
                        })}
                      </MenuList>
                    )}
                  </Menu>
                </Tooltip>

                <Grid
                  templateColumns="120px 1fr"
                  rowGap={5}
                  columnGap={6}
                  alignItems="start"
                >
                  <Text fontWeight="semibold">Assignee</Text>
                  <Tooltip
                    label={!isEditable ? 'You do not have permission' : ''}
                  >
                    <Popover
                      isOpen={showEmployeePicker}
                      onClose={() => setShowEmployeePicker(false)}
                    >
                      <Box position="relative" width="fit-content">
                        <PopoverTrigger>
                          <HStack
                            spacing={2}
                            onClick={() =>
                              setShowEmployeePicker(!showEmployeePicker)
                            }
                            cursor="pointer"
                          >
                            {selectedEmployee?.username ||
                            taskdata?.assignee_name ? (
                              <>
                                <UserAvatar
                                  username={
                                    selectedEmployee?.username ||
                                    taskdata?.assignee_name
                                  }
                                  size={24}
                                />
                                <Text fontSize="sm">
                                  {selectedEmployee?.username ||
                                    taskdata?.assignee_name}
                                </Text>
                              </>
                            ) : (
                              <HStack spacing={1} color="gray.500">
                                <MdOutlinePerson size={20} />
                                <Text fontSize="sm">Unassigned</Text>
                              </HStack>
                            )}
                          </HStack>
                        </PopoverTrigger>
                      </Box>
                      {isEditable && (
                        <PopoverContent width="auto">
                          <PopoverBody>
                            {assigneeList?.length > 0 ? (
                              <Box maxH="200px" overflowY="auto">
                                {assigneeList?.map((emp) => (
                                  <Box
                                    key={emp.user_id}
                                    onClick={() => {
                                      setSelectedEmployee(emp);
                                      setShowEmployeePicker(false);
                                      handleTaskUpdate(emp);
                                    }}
                                    display="flex"
                                    alignItems="center"
                                    px={2}
                                    py={1}
                                    borderRadius="md"
                                    cursor="pointer"
                                    bg={
                                      selectedEmployee?.user_id === emp.user_id
                                        ? '#e6f4ff'
                                        : 'transparent'
                                    }
                                    _hover={{ bg: '#f1f5f9' }}
                                  >
                                    <UserAvatar
                                      username={emp.username}
                                      size={24}
                                      style={{ marginRight: '8px' }}
                                    />
                                    <Text fontSize="sm">{emp.username}</Text>
                                  </Box>
                                ))}
                              </Box>
                            ) : (
                              <Text fontSize="sm" color="gray.500">
                                No employees found
                              </Text>
                            )}
                          </PopoverBody>
                        </PopoverContent>
                      )}
                    </Popover>
                  </Tooltip>

                  <Text fontWeight="semibold">Labels</Text>
                  {/* <Box w="100%">
                       <CreatableSelect
                         placeholder="Select or create label"
                         isClearable
                         isMulti
                         value={selectedLabel}
                         options={labellist.map((label) => ({
                           label: label.label_name,
                           value: label.label_id,
                         }))}
                         onChange={(newValue) => setSelectedLabel(newValue || [])}
                         formatCreateLabel={(inputValue) =>
                           `Create new label: "${inputValue}"`
                         }
                       />
                     </Box> */}
                  <Box w="100%">
                    {/* <CreatableSelect
                                       placeholder="Select or create label"
                                       isClearable
                                       isMulti
                                       value={
                             selectedLabel.length > 0
                               ? selectedLabel
                               : (taskdata?.labels || []).map((label) => ({
                                   label: label.label_name || label,
                                   value: label.label_id || label,
                                 }))
                           }
                                       options={labellist.map((label) => ({
                                         label: label.label_name,
                                         value: label.label_id,
                                         __isNew__: false,
                                       }))}
                                       onChange={(newValue) => {
                                         setSelectedLabel(newValue || []);
                                       }}
                                       formatCreateLabel={(inputValue) =>
                                         `Create new label: "${inputValue}"`
                                       }
                                     /> */}

                    <CreatableSelect
                      isDisabled={![1, 2, 3].includes(roleId)}
                      isClearable
                      isMulti
                      placeholder="Select or create label"
                      value={selectedLabel} // ✔ ONLY this
                      options={labellist?.map((label) => ({
                        label: label.label_name,
                        value: label.label_id,
                        __isNew__: false,
                      }))}
                      onChange={(newValue) => {
                        const updated = newValue || [];

                        setSelectedLabel(updated);
                        handleAddLabel(updated); // ← Pass updated list
                      }}
                    />
                  </Box>

                  <Text fontWeight="semibold">Parent</Text>
                  <CreatableSelect
                    isDisabled={![1, 2, 3].includes(roleId)}
                    placeholder="Select Parent"
                    isClearable
                    value={selectedparent}
                    onChange={(selected) => {
                      setSelectedParent(selected);
                      handleTaskUpdate();
                    }}
                    options={epicList?.map((epic) => ({
                      value: epic.epic_id,
                      label: epic.epic_name,
                    }))}
                  />

                  <Text fontWeight="semibold">Due date</Text>
                  <Input
                    type="date"
                    size="sm"
                    value={dueDate || taskdata?.formatdue_date}
                    onChange={(e) => setDueDate(e.target.value)}
                    onBlur={handleTaskUpdate}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleTaskUpdate(); // ✅ Save on Enter
                        e.target.blur();
                      }
                    }}
                    isDisabled={![1, 2, 3].includes(roleId)}
                  />

                  <Text fontWeight="semibold">Start date</Text>
                  <Input
                    type="date"
                    size="sm"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    onBlur={handleTaskUpdate}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleTaskUpdate();
                        e.target.blur();
                      }
                    }}
                    isDisabled={![1, 2, 3].includes(roleId)}
                  />

                  <Text fontWeight="semibold">Sprint</Text>
                  <Text>
                    {/* {taskDetails?.task?.sprint_name || taskDetails?.sprint_name || 'SCRUM Sprint 1'} */}
                    <CreatableSelect
                      isDisabled={![1, 2, 3].includes(roleId)}
                      placeholder="Select or create sprint"
                      isClearable
                      value={
                        selectedSprint ||
                        sprintOptions?.find(
                          (s) => s.label === taskdata?.sprint_name,
                        ) ||
                        (taskdata?.sprint_name
                          ? {
                              label: taskdata.sprint_name,
                              value: taskdata.sprint_id,
                            }
                          : null)
                      }
                      options={sprintOptions}
                      onChange={(newValue) => {
                        setSelectedSprint(newValue);
                        handleTaskUpdate();
                      }}
                      formatCreateLabel={(inputValue) =>
                        `Create new sprint: "${inputValue}"`
                      }
                    />
                  </Text>

                  <Text fontWeight="semibold">Story points</Text>
                  <Input
                    size="sm"
                    placeholder="Add story points"
                    w="100%"
                    type="number"
                    value={storyPoints}
                    onChange={(e) => setStoryPoints(e.target.value)}
                    onBlur={debouncedUpdate}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleTaskUpdate();
                        e.target.blur();
                      }
                    }}
                    isDisabled={![1, 2, 3].includes(roleId)}
                  />

                  <Text fontWeight="semibold">Development</Text>
                  <VStack align="start" spacing={2}></VStack>

                  <Text fontWeight="semibold">Reporter</Text>
                  <HStack align="center" spacing={2}>
                    <Avatar
                      name={taskdata?.task_created_by_name || 'Unknown'}
                      size="xs"
                    />
                    <Text fontSize="sm" lineHeight="1">
                      {taskdata?.task_created_by_name || 'Unknown'}
                    </Text>
                  </HStack>
                </Grid>
                <div
                  style={{
                    marginTop: 20,
                    padding: '12px 16px',
                    // border: '1px solid #e6e6e6',
                    borderRadius: 8,
                    // background: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                  }}
                >
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                  >
                    <span style={{ width: 120, fontWeight: 300 }}>
                      Created at
                    </span>
                    <Text style={{ color: '#333' }}>
                      {taskdata?.created_at
                        ? dayjs(taskdata?.created_at).format(
                            'DD MMM YYYY, hh:mm A',
                          )
                        : 'Unknown'}
                    </Text>
                  </div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                  >
                    <span style={{ width: 120, fontWeight: 300 }}>
                      Updated at
                    </span>
                    <Text style={{ color: '#333' }}>
                      {taskdata?.updated_at
                        ? dayjs(taskdata?.updated_at).format(
                            'DD MMM YYYY, hh:mm A',
                          )
                        : 'Unknown'}
                    </Text>
                  </div>
                </div>
              </Box>
            </Flex>
          )}
          {/* <Box
         ref={resizerRef}
         position="fixed"
         top="0"
         right={`${panelWidth}px`}
         height="100vh"
         width="10px"
         zIndex="1500"
         cursor="ew-resize"
         onMouseDown={onMouseDownResizer}
         onTouchStart={onTouchStartResizer}
         _hover={{ backgroundColor: 'rgba(0,0,0,0.02)' }}
       >
         <Box
           position="absolute"
           top="50%"
           left="0"
           transform="translateY(-50%)"
           width="2px"
           height="56px"
           bg="gray.300"
           marginLeft="4px"
           borderRadius="md"
         />
       </Box>
          */}

          {subtaskmodal && selectedSubtask && (
            <SubTaskModal
              isOpen={subtaskmodal}
              subtaskdetails={selectedSubtask}
              onClose={handlesubtaskmodal}
              taskDetails={taskDetails}
              assigneeList={assigneeList}
            />
          )}
          <Modal
            isOpen={epicModalOpen}
            onClose={() => setEpicModalOpen(false)}
            isCentered
          >
            <ModalOverlay />
            <ModalContent maxW="700px" minH="300px">
              {' '}
              {/* Increase width here */}
              <ModalHeader>Add Epic</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Text mb={3}>
                  Select a parent work item. Work items can only belong to one
                  parent at a time.
                </Text>
                <Select
                  placeholder="Select Parent"
                  value={selectedEpic}
                  onChange={(e) => setSelectedEpic(Number(e.target.value))} // force same type
                  mt={3}
                >
                  {epicList?.map((epic) => (
                    <option key={epic.epic_id} value={epic.epic_id}>
                      {epic.epic_name}
                    </option>
                  ))}
                </Select>
              </ModalBody>
              <ModalFooter>
                <Button
                  colorScheme="blue"
                  mr={3}
                  onClick={() => {
                    // Replace with API call
                    setEpicModalOpen(false);
                  }}
                >
                  Add
                </Button>
                <Button variant="ghost" onClick={() => setEpicModalOpen(false)}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Box>
      </div>
    </Card>
  );
};

export default NewTabtaskdetails;
